import { useHttp } from '../http'

export const useUserCommentHttp = () => {

    const find = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().get(`user-comments/${id}`, payload)
    }

    const create = <T>(payload: any): Promise<T> => {
        return useHttp().post(`user-comments`, payload)
    }

    const update = <T>(id: number, payload: any): Promise<T> => {
        return useHttp().put(`user-comments/${id}`, payload)
    }

    const get = <T>(payload: any): Promise<T> => {
        return useHttp().get(`user-comments`, payload)
    }

    const del = <T>(id: number): Promise<T> => {
        return useHttp().del(`user-comments/${id}`)
    }

    return {
        find,
        create,
        update,
        get,
        del,
    }
}
